type SavedRecording = { key: string; postId: string; blob: Blob; name: string; order?: number }

const database = () =>
  new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open("social-coordinator-recordings", 1)
    request.onupgradeneeded = () => request.result.createObjectStore("sections", { keyPath: "key" })
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })

export async function rememberRecording(recording: SavedRecording) {
  const db = await database()
  try {
    await new Promise<void>((resolve, reject) => {
      const transaction = db.transaction("sections", "readwrite")
      transaction.objectStore("sections").put(recording)
      transaction.oncomplete = () => resolve()
      transaction.onerror = () => reject(transaction.error)
    })
  } finally {
    db.close()
  }
}

export async function forgetRecording(key: string) {
  const db = await database()
  try {
    await new Promise<void>((resolve, reject) => {
      const transaction = db.transaction("sections", "readwrite")
      transaction.objectStore("sections").delete(key)
      transaction.oncomplete = () => resolve()
      transaction.onerror = () => reject(transaction.error)
    })
  } finally {
    db.close()
  }
}

export async function recoverRecordings(postId: string): Promise<SavedRecording[]> {
  const db = await database()
  try {
    const records = await new Promise<SavedRecording[]>((resolve, reject) => {
      const request = db.transaction("sections").objectStore("sections").getAll()
      request.onsuccess = () => resolve(request.result as SavedRecording[])
      request.onerror = () => reject(request.error)
    })
    return records
      .filter((record) => record.postId === postId)
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
  } finally {
    db.close()
  }
}
